// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { LegalOperationsService } from '../generated/api/legalOperations.service';

@Injectable({ providedIn: 'root' })
export class LegalOperationsClientService {
  constructor(private readonly client: LegalOperationsService) {}
  // <generated-client-wrappers:methods>
  archiveVersion(
    versionId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsArchiveVersion(
      versionId,
      'body',
      reportProgress,
      options,
    );
  }

  createDocument(
    request: WrapperApi.LegalDocumentSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsCreateDocument(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  createVersion(
    documentId: string,
    request: WrapperApi.LegalDocumentVersionSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsCreateVersion(
      documentId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  getDocument(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalDocumentDetail> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsGetDocument(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  publishVersion(
    versionId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsPublishVersion(
      versionId,
      'body',
      reportProgress,
      options,
    );
  }

  queryAcceptances(
    request: WrapperApi.LegalAcceptanceQueryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalAcceptancePage> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsQueryAcceptances(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  queryDocuments(
    request: WrapperApi.LegalDocumentQueryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalDocumentPage> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsQueryDocuments(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  updateDocument(
    id: string,
    request: WrapperApi.LegalDocumentSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('LegalOperationsService is not available');
    return this.client.legalOperationsUpdateDocument(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
